import React from 'react'

import lasertreetment from "../images/berhampore lsc.jpeg";



function Aboutus() {
    return (
        <div>
  
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b>About Us</b>– Berhampore Laser Sitting Centre</h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'>Welcome to <b style={{color:"#ED1B24"}}>Berhampore Laser Sitting Centre </b>–</h3>
                                           <p style={{color:"#1D4D93"}} className='mb-2'>Dear Visitors,</p>
                

                                    <p className='justify mb-2'>Berhampore Laser Sitting Centre is a trusted destination for advanced laser, skin, hair, and cosmetic surgery treatments in Berhampore, Murshidabad. Located at 122, Pilkhana Road, Ranibagan, our centre is dedicated to providing modern, safe, and result-oriented aesthetic and medical solutions.</p>
                                    <p className='justify mb-1'>We specialize in a wide range of laser and cosmetic procedures using advanced technology and professional medical expertise. Our goal is to help patients improve their appearance, confidence, and overall well-being through effective and scientifically proven treatments.</p>
                                    <p className='justify mb-1'>At Berhampore Laser Sitting Centre, we offer services such as Hair Transplantation (FUE/FUT), Laser Hair Reduction, Laser Tattoo Removal, Laser Spot Removal, Mole & Wart Removal, Electro and Chemical Cautery, Keloid & Scar Treatment, and several cosmetic surgery procedures including Rhinoplasty (Nose Job), Liposuction, Breast Implantation, Gynecomastia Surgery, Breast Reduction, and Facial Surgery.</p>
                                    <p style={{color:"#1D4D93"}}><b>Whether you are looking for <b>skin treatments, hair restoration, laser procedures, or cosmetic surgery,</b> Berhampore Laser Sitting Centre is committed to helping you achieve a healthier and more confident version of yourself.</b></p>
                            
                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">

                                        <img src={lasertreetment} className="card-img-top" alt="lasertreetment"/>


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />


        </div>
    )
}

export default Aboutus